import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyBVcIzTxZmYfz5ypYb-hxT6lbHlAVedbAQ",
    authDomain: "cusaly.firebaseapp.com",
    databaseURL: "https://cusaly.firebaseio.com",
    projectId: "cusaly",
    storageBucket: "cusaly.appspot.com",
    messagingSenderId: "706404087469"
};

firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true })


export default firebase;